const authRoles = {
  SuperAdmin: ['TmcSupport'],
  UserAdmins: ['UserAdministration'],
  TmcRestoreDb: ['TmcRestoreDatabase'],
  AuditUsers: ['AuditUser'],
  AuditLogAdmins: ['AuditLogAdministration'],
  SettingsUsers: ['SettingsUser'],
  BankProfileAdmins: ['BankProfileAdministration'],
  ImportExportAdmins: ['ImportExportAdministration'],
  TaxAdmin: ['TaxAdministration'],
  CommonUsers: ['CommonUser'],
  SharedListAdmins: ['SharedListAdministration'],
  UnregisteredDepositUser: ['UnregisteredDepositUser'],
  PaymentAdmin: ['PaymentsAdministration'],
  WarEdit: [
    'WarAdministration',
    'WarUser',
  ],
  WarRead: [
    'WarAdministration',
    'WarUser',
    'ReadOnly',
  ],
  OD: [
    'ODAdministration',
    'ODUser',
  ],
  ODRead: [
    'ODAdministration',
    'ODUser',
    'ReadOnly',
    'UnregisteredDepositUser',
  ],
  MiscAuth: [
    'MiscAdministration',
    'MiscUser',
  ],
  MiscRead: [
    'MiscAdministration',
    'MiscUser',
    'ReadOnly',
  ],
  MtgAuth: [
    'MtgAdministration',
    'MtgUser',
  ],
  MtgRead: [
    'MtgAdministration',
    'MtgUser',
    'ReadOnly',
  ],
  GlAuth: [
    'GLAdministration',
    'GLUser',
  ],
  GlRead: [
    'GLAdministration',
    'GLUser',
    'ReadOnly',
  ],
  TaxAuth: [
    'TaxAdministration',
    'TaxUser',
  ],
  /**
   * Sterilised Tax Inquiry (Tulsa / Assessor's office): the Tax Inquiry screen and nothing else.
   *
   * It is listed in TaxRead so the Tax Inquiry queries resolve, but filterByAuthInRoles in
   * store/auth/token.js strips it back out again unless the caller opts in explicitly. Without
   * that, every `[...authRoles.TaxRead, ...]` route guard (Comments, Payments, Adjustments,
   * TR Work File, Apportionment, Delinquent/Special Tax, Mortgage Co) and authRoles.shared
   * would have opened up too.
   */
  TaxInquiryViewOnly: [
    'TaxInquiryViewOnly',
  ],
  TaxRead: [
    'TaxAdministration',
    'TaxUser',
    'ReadOnly',
    'TaxInquiryViewOnly',
  ],
  PaymentsAuth: [
    'PaymentsAdministration',
    'PaymentsUser',
  ],
  AjustmentAuth: [
    'AjustmentAdministration',
    'AdjustmentUser',
  ],
  MortgageCoAdmin: ['MortgageCoAdministration'],
  MortgageCoAuth: [
    'MortgageCoAdministration',
    'MortgageCoUser',
  ],
  DelinquentTaxAuth: [
    'DelinquentTaxAdministration',
    'DelinquentTaxUser',
  ],
  SpecialTaxAuth: [
    'SpecialTaxAdministration',
    'SpecialTaxUser',
  ],
  ApportionmentAuth: [
    'ApportionmentAdministration',
    'ApportionmentUser',
  ],
};

authRoles.shared = {
  BankAuth: [
    ...authRoles.WarEdit,
    ...authRoles.OD,
    ...authRoles.MiscAuth,
    ...authRoles.MtgAuth,
    ...authRoles.GlAuth,
    ...authRoles.TaxAuth,
  ],
  SharedProgram: [
    ...authRoles.WarRead,
    ...authRoles.ODRead,
    ...authRoles.MiscRead,
    ...authRoles.MtgRead,
    ...authRoles.GlRead,
    ...authRoles.TaxRead,
    ...authRoles.SharedListAdmins,
    ...authRoles.SuperAdmin,
  ],
  SharedListAdmin: [
    ...authRoles.SharedListAdmins,
    ...authRoles.SuperAdmin,
  ],
  BankRead: [
    ...authRoles.WarRead,
    ...authRoles.ODRead,
    ...authRoles.MiscRead,
    ...authRoles.MtgRead,
    ...authRoles.GlRead,
    ...authRoles.TaxRead,
  ],
};

export { authRoles };

export default { authRoles };
